module.exports = __webpack_public_path__ + "static/media/Lock.286d97f2.svg";